import { EventBus, EventName, Callback, Subscription, Publisher } from './event-bus'

type SubscriptionId = string;
type EventSubscriptions = Map<SubscriptionId, Callback>

export default class WidgetEventBus implements EventBus {
  private subscriptions: Map<EventName, EventSubscriptions>
  private logErrors: boolean

  public constructor (logErrors: boolean) {
    this.subscriptions = new Map<EventName, EventSubscriptions>()
    this.logErrors = logErrors
  }

  public subscribe (eventName: EventName, callback: Callback): Subscription {
    const id = this.getRandomId()

    let eventSubscriptions = this.subscriptions.get(eventName)
    if (!eventSubscriptions) {
      eventSubscriptions = new Map<SubscriptionId, Callback>()
      this.subscriptions.set(eventName, eventSubscriptions)
    }

    eventSubscriptions.set(id, callback)

    const subscription: Subscription = {
      eventName: eventName,
      callback: callback,
      unsubscribe: (): void => {
        if (eventSubscriptions) {
          eventSubscriptions.delete(id)
        }
      }
    }
    return subscription
  }

  public publish (eventName: EventName, publisher: Publisher, ...args: any[]): void {
    const eventSubscriptions = this.subscriptions.get(eventName)
    if (!eventSubscriptions) {
      return
    }

    eventSubscriptions.forEach((callback: Callback): void => {
      try {
        callback(publisher, ...args)
      } catch (error) {
        if (this.logErrors) {
          console.error(error)
        }
      }
    })
  }

  private getRandomId (): string {
    return Math.random().toString(36).substr(2, 9)
  }
}
